import { Button, Chip, H1, H3, } from "@bracket/ui";
import type { FunctionComponent } from "react";
import styled from "styled-components";


export declare type FourOhFourProps = object;

export const FourOhFour: FunctionComponent<FourOhFourProps> = () => {

	return (
		<FourOhFourContainer>
			<Screen>
				<div className="brace">
					<div className="chipped">
						<Chip>
							<H1 $type="numeric" $color="primary">404</H1>
						</Chip>
					</div>
					<H3>Page not found</H3>
					<div className="button-bar">
						<Button
							label="Return home"
							onClick={() => {
								window.location.href = "/";
							}}
						/>
					</div>
				</div>
			</Screen>
		</FourOhFourContainer>
	);
};

const FourOhFourContainer = styled.div`
	position: fixed;
	top: 0rem;
	left: 0rem;
	width: 100%;
	height: 100%;
	background-color: black;
`;

const Screen = styled.div`
	display: flex;
	width: 100%;
	height: 100%;
	align-items: center;
	justify-items: center;
	justify-content: center;
	text-align: center;
	background: url("/assets/fourohfourbg.png");
	background-size: 100% 80%;
	background-position: bottom;
	background-repeat:  no-repeat;
	.chipped {
		align-items:center;
	}

	.brace {
		flex: 0;
	}

	.button-bar {
		padding: 2rem;
		display: flex;
		gap: 1rem;
		justify-content: center;
		flex-direction: row;
	}

	h3 {
		white-space: nowrap;
	}
`;
